import { render, staticRenderFns } from "./VueScrollTable.vue?vue&type=template&id=82532f14&"
import script from "./VueScrollTable.vue?vue&type=script&lang=js&"
export * from "./VueScrollTable.vue?vue&type=script&lang=js&"
import style0 from "./VueScrollTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports